import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * /assets/stocktake/<place> - where shelf labels and the Storage panel's
 * Stocktake button lead. Since 29 October 2026 every place is counted on the
 * one screen in Lookup, by one person or several (components/StockTake.js):
 * this joins the count that covers the place, or offers to start one.
 */
export default function AssetStocktake() {
  const { locationId } = useParams();
  return <Navigate to={`/assets/lookup?count=${encodeURIComponent(locationId)}`} replace />;
}
